import React, { useReducer } from 'react';
import { AuthContext } from './auth.context';

const isBrowser = typeof window !== 'undefined';

const INITIAL_STATE = {
  isAuthenticated: isBrowser && !!localStorage.getItem('access_token'),

  name: localStorage.getItem('name'),
  userId: localStorage.getItem('userId'),
  userRole: localStorage.getItem('userRole'),
  firstPasswordChanged: localStorage.getItem('firstPasswordChanged'),
  profilePicture: localStorage.getItem('profilePicture'),
  deptId: localStorage.getItem('deptId'),

  // isAuthenticated: true ,
  currentForm: 'signIn',
};
//console.log('INITIAL_STATE', INITIAL_STATE);
function reducer(state, action) {
  // console.log(state, 'auth');

  switch (action.type) {
    case 'SIGNIN':
      return {
        ...state,
      };
    case 'SIGNIN_SUCCESS':
      return {
        ...state,
        isAuthenticated: true,
        name: action.name,
        userId: action.userId,
        userRole: action.userRole,
        firstPasswordChanged: action.firstPasswordChanged,
        profilePicture: action.profilePicture,
        deptId: action.deptId,
      };
    case 'SIGN_OUT':
      return {
        ...state,
        isAuthenticated: false,
      };
    case 'UPDATE_USER':
      return {
        ...state,
        profilePicture: action.profilePicture,
      };
    default:
      return state;
  }
}

export const AuthProvider = ({ children }) => {
  const [authState, authDispatch] = useReducer(reducer, INITIAL_STATE);
  return <AuthContext.Provider value={{ authState, authDispatch }}>{children}</AuthContext.Provider>;
};
